import { cn } from "@/lib/utils";

interface TvIdPillProps {
  id?: string;
  className?: string;
}

/**
 * The tutor version id, and nothing else.
 *
 * Version names routinely quote another id ("tv-74 + drop managed bite…"), so a
 * plain "tv-75 — tv-74 + …" line reads as two ids with no way to tell which one
 * the row is about. The pill marks the real id everywhere it appears.
 */
export const TvIdPill = ({ id, className }: TvIdPillProps) => (
  <code
    className={cn(
      "shrink-0 rounded-full border bg-muted px-2 py-0.5 font-mono text-[11px] leading-none",
      className,
    )}
  >
    {id ?? "—"}
  </code>
);
